import { useState } from "react";
import axios from "axios";

const useCacheRefresh = (onRefreshComplete) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const handleRefreshData = async () => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);

    try {
      // Récupérer le token JWT à partir du stockage
      const token = sessionStorage.getItem("token");

      // Ajouter le token au header de la requête
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        process.env.REACT_APP_DOMAIN_URL+"/api/ftpdata/refresh-cache",
        config
      );
      setSuccessMessage(response.data.message);
      setLoading(false);

      if (onRefreshComplete) {
        onRefreshComplete();
      }
    } catch (error) {
      setError(
        "Erreur lors du rafraîchissement du cache FTP: " + error.message
      );
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    successMessage,
    handleRefreshData,
  };
};

export default useCacheRefresh;
